import { render } from "./FeedbackSection.vue?vue&type=template&id=7b68209e&scoped=true"
import script from "./FeedbackSection.vue?vue&type=script&lang=js"
export * from "./FeedbackSection.vue?vue&type=script&lang=js"

import "./FeedbackSection.vue?vue&type=style&index=0&id=7b68209e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b68209e"]])

export default __exports__